export default __webpack_public_path__ + "static/media/logo_stage_nav.ec4bb6e4.png";